import React, { Component } from 'react'
import moment from 'moment'
import { withStyles } from 'material-ui/styles'
import Paper from 'material-ui/Paper'
import { graphql } from 'react-apollo'
import { UPDATE_DATASET, DELETE_DATASET } from '@/graphql/mutations/dataset'
import { READ_DATASET, READ_DATASETS } from '@/graphql/queries/dataset'
import HeaderAlchemy from '@/components/HeaderAlchemy'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import ReactFileReader from 'react-file-reader'
import csv from 'csvtojson'
import { GC_USER_ID } from '@/constants'

const sharedId = 'cjk5rjfqc91pk0161mebhza1v'

const styles = theme => ({
  root: {
    width: '90%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  tableWrapper: {
    overflowX: 'auto'
  }
})

@graphql(READ_DATASET, {
  name: 'readDataSet',
  options: ({ match }) => ({
    variables: {
      dataSetID: match.params.id
    }
  })
})
@graphql(DELETE_DATASET, { name: 'deleteDataSet' })
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@graphql(READ_DATASETS)
@withStyles(styles)
export default class DatasetsSingle extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  getColumns = data => {
    const columns = []
    const sample = data[0]
    for (let key in sample) {
      columns.push({
        accessor: key,
        Header: key,
        style: { whiteSpace: 'normal' }
      })
    }
    return columns
  }

  updateDatePoints = async dataPoints => {
    await this.props.UpdateDataSet({
      variables: {
        datasetId: this.props.readDataSet.DataSet.id,
        dataPoints: dataPoints
      },
      update: () => {
        console.log('Data updated')
      }
    })
  }

  deleteDataset = async () => {
    await this.props.deleteDataSet({
      variables: {
        datasetId: this.props.match.params.id
      },
      update: (store, { data: { deleteDataSet } }) => {
        console.log(deleteDataSet.id)
        const data = store.readQuery({ query: READ_DATASETS })
        data.allDataSets = data.allDataSets.filter(
          dataset => dataset.id !== deleteDataSet.id
        )
        store.writeQuery({ query: READ_DATASETS, data })

        console.log('Data deleted')
        this.props.history.push(`/datasets`)
      }
    })
  }

  handleFiles = files => {
    const reader = new window.FileReader()
    reader.readAsText(files[0])
    reader.onload = () => {
      csv()
        .fromString(reader.result)
        .on('end_parsed', dataPoints => {
          this.updateDatePoints(JSON.stringify(dataPoints))
        })
    }
  }

  render() {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (this.props.readDataSet.loading) {
      return <div>Loading</div>
    }

    if (
      userId !== this.props.readDataSet.DataSet.author.id &&
      userId !== sharedId
    ) {
      return <div>Permision required </div>
    }

    const dataPoints = JSON.parse(this.props.readDataSet.DataSet.dataPoints)
    const columns = this.getColumns(dataPoints)
    return (
      <div>
        <HeaderAlchemy />
        <Paper className={this.props.classes.root}>
          <div className={this.props.classes.tableWrapper}>
            <ReactTable
              data={dataPoints}
              columns={columns}
              defaultPageSize={10}
              className="-striped -highlight"
            />
          </div>
        </Paper>
        <div>Data set name: {this.props.readDataSet.DataSet.name}</div>
        <div>
          Data set description: {this.props.readDataSet.DataSet.description}
        </div>
        <div>Author: {this.props.readDataSet.DataSet.author.name}</div>
        <div>
          Created at:{' '}
          {moment(this.props.readDataSet.DataSet.createdAt).calendar()}
        </div>
        <div>
          Updated at:{' '}
          {moment(this.props.readDataSet.DataSet.updatedAt).fromNow()}
        </div>
        <div>====== Update data ====== </div>

        <br />
        <ReactFileReader handleFiles={this.handleFiles} fileTypes={'.csv'}>
          <button className="btn">Update Data</button>
        </ReactFileReader>

        <br />
        <div>====== Delete data ====== </div>
        <br />
        <button onClick={() => this.deleteDataset()} className="btn">
          Delete Data
        </button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/datasets/single.js